export function Color() {
  return {
    primaryColor: "rgb(12, 116, 248)",
    secondaryColor: "rgb(189, 205, 255)",
    tertiaryColor: "rgb(240, 245, 255)",
    whiteColor: "rgb(255, 255, 255)",
    blackColor: "rgb(0, 0, 0)",
    disableColor: "rgba(100, 100, 100, 0.5)",
    focusColor: "rgb(24, 144, 255)",
    errorColor: "rgb(255, 0, 0)",
  };
}
